export default {
      id: "units__moving_symbol-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#units__moving_symbol",
      toString: function () {
        return this.url;
      }
    }